import { AiOutlinePlus } from 'react-icons/ai';
import { BriefcaseIcon } from '../../../../../../assets/svg/briefcase';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../../assets/svg/sort';
import { Button } from '../../../../../../components/button/button';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { useEmployeesUtils } from '../use-employees-utils';
import s from './employees-controls.module.css';
import { JobTitlesModal } from './job-titles-modal/job-titles-modal';

export const EmployeesControls = () => {
  const { t, tag, branches, jobTitlesModal, createEmployeeModal } = useEmployeesUtils();

  return (
    <div className={s.feature}>
      <HasAccess service="staff" permissions={['write']}>
        {jobTitlesModal.isOpen && (
          <JobTitlesModal onClose={() => jobTitlesModal.handleCloseModal(['id', 'staffName'])} />
        )}
      </HasAccess>

      <DropdownStyleView />

      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at-desc', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at-asc', dir: 'asc' },
        ]}
      />

      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По сотруднику'),
            value: 'employee',
            filter: 'input',
          },
          {
            label: t('По статусу'),
            value: 'shift_state',
            filter: 'single-select',
            filterOptions: [
              {
                id: 'ON_SHIFT',
                value: t('На смене'),
              },
              {
                id: 'OFF_SHIFT',
                value: t('Не на смене'),
              },
            ],
          },
          {
            label: t('По должностям'),
            value: 'tags',
            filter: 'multi-select',
            filterOptions: tag,
          },
          {
            label: t('По филиалам'),
            value: 'place_ids',
            filter: 'multi-select',
            filterOptions: branches.map((item) => ({
              id: item.id,
              value: item.value,
            })),
          },
          {
            label: t('По дате добавления'),
            value: 'created_at',
            filter: 'datetime-range',
          },
        ]}
      />

      <HasAccess service="staff" permissions={['write']}>
        <IconButton
          size="lg"
          onClick={() => jobTitlesModal.handleOpenModal()}
          data-testid="job-titles-button"
          style={{
            borderRadius: 8,
            width: 40,
            height: 40,
          }}
        >
          <BriefcaseIcon />
        </IconButton>

        <Button
          size="lg"
          onClick={() => createEmployeeModal.handleOpenModal()}
          data-test-id="add-employee-button"
        >
          <AiOutlinePlus />
          {t('Добавить сотрудника')}
        </Button>
      </HasAccess>
    </div>
  );
};
